export const BtnOutlineWhite: FcBtn = (props) => (
  <button
    {...props}
    type="button"
    className="flex items-center justify-center gap-[0.625rem] rounded-full border-[1px] border-solid border-[#FFFFFF] px-4 py-2 text-center text-base text-[#FFFFFF] sm:px-[2.9375rem] sm:py-[0.75rem] sm:leading-[1.375rem]"
  >
    {props.children}
  </button>
);
